export default "__VITE_ASSET__Bs_ifjbz__"